import React, { PropTypes } from 'react';
import AddItemCard from '../../../generic-components/add-item-card/add-item-card';
import EditButton from '../../../generic-components/edit-button';
import MouseOverEditDiv from '../../../../tc-ui/mouse-over-edit-div';
import pluralize from 'pluralize';
import HelperLink from '../../product/helper-link';

const FamilyChildPolicy = ({ childInfo, editChild, addChild, supplierEditable, deletePolicy, inMaster, classes = {} }) => {
  if (!(childInfo && Object.keys(childInfo).length)) {
    return (<div>
      <div id="childPolicy">
        <HelperLink value="child" justLabel={inMaster}>Child Policy</HelperLink>
      </div>
      <AddItemCard
        onClick={addChild}
        text="Add child policy"
        editable={supplierEditable}
      />
    </div>);
  }
  return (
    <div id="childPolicy">
      <HelperLink
        value="child"
        openEditDialog={editChild}
        labelText="Child Policy"
        justLabel={inMaster}
      />
      <MouseOverEditDiv
        className={classes.main}
        editable={supplierEditable}
        extendPadding
        actionButtons={<EditButton onEdit={editChild} deleteButton={Boolean(deletePolicy)} onDelete={deletePolicy} />}
      >
        {childInfo.ageFrom >= 0 ? <span className={classes['ageFrom']}>From {childInfo.ageFrom} to </span> : null}
        {childInfo.ageTo > 0 ? <span className={classes['ageTo']}>{childInfo.ageTo} (inclusive)</span> : null}
        {childInfo.focChildrenCount > 0 && <div>* <span className={classes['focChildrenCount']}>{childInfo.focChildrenCount}</span> {pluralize('child', childInfo.focChildrenCount)} {pluralize('is', childInfo.focChildrenCount)} Free of Charge when sharing existing bedding with adults. *</div>}
        {
          childInfo.childrenNotAccepted ? (
            <div className={classes.childrenNotAccepted}>* Children not accepted *</div>
          ) : null
        }
        <div style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', display: (childInfo.conditions || '').trim().toLowerCase() !== 'na' ? 'block' : 'none' }}>
          {classes['conditions-textblock'] || childInfo.conditions}
        </div>
      </MouseOverEditDiv>
    </div>
  );
};

FamilyChildPolicy.propTypes = {
  hideLabel: PropTypes.bool,
  childInfo: PropTypes.object,
  editFamilyChild: PropTypes.func,
  addFamilyChild: PropTypes.func,
  supplierEditable: PropTypes.bool,
  inMaster: PropTypes.bool,
};

export default FamilyChildPolicy;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-policies/policies/child.jsx